module.exports = __webpack_public_path__ + "img/slqy.c18e168f.png";